export default __webpack_public_path__ + "static/baner1-8083a5694e58edd21f5d7c46c3ab6b11.png";